function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var MeshingService = /*#__PURE__*/function (_lm$Composant) {
  function MeshingService(id) {
    var _this;
    _classCallCheck(this, MeshingService);
    _this = _callSuper(this, MeshingService, [id]);
    _this.initMeshing();
    return _this;
  }

  /**
    * Checks the presence of the mesh and imports the necessary js during runtime
   * @returns void
   */
  _inherits(MeshingService, _lm$Composant);
  return _createClass(MeshingService, [{
    key: "initMeshing",
    value: function initMeshing() {
      var _this2 = this;
      var buttons = document.querySelectorAll('.js-mesh');
      buttons.forEach(function (mesh) {
        switch (mesh.id) {
          case 'pushService':
            import(/* webpackChunkName: "push" */'./subcomponents/c-pushService.class').then(function (module) {
              _this2.loadMeshing(module);
            });
            break;
          case 'leadService':
            import(/* webpackChunkName: "lead" */'./subcomponents/c-leadService.class').then(function (module) {
              _this2.loadMeshing(module);
            });
            break;
          case 'finalService':
            import(/* webpackChunkName: "final" */'./subcomponents/c-final.class').then(function (module) {
              _this2.loadMeshing(module);
            });
            break;
          case 'installationService':
            import(/* webpackChunkName: "final" */'./subcomponents/c-installationService.class').then(function (module) {
              _this2.loadMeshing(module);
            });
            break;
          default:
            break;
        }
      });
    }
  }, {
    key: "loadMeshing",
    value: function loadMeshing(module) {
      try {
        new module["default"]();
      } catch (error) {
        throw new Error("Error : ".concat(error));
      }
    }
  }]);
}(lm.Composant);
export { MeshingService as default };
window.addEventListener('load', function () {
  if (document.querySelector('.js-meshing-component')) {
    try {
      new MeshingService('meshingservice');
    } catch (error) {
      throw new Error("Error : ".concat(error));
    }
  }
});